// removed by extract-text-webpack-plugin
module.exports = {"suggestion-step":"suggestion-step","subtitle":"subtitle","features-list":"features-list","feature":"feature","feature-icon":"feature-icon","feature-content":"feature-content","btn-primary":"btn-primary"};


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/conversion-quiz/steps/suggestion/suggestion.style.sass
// module id = hr//
// module chunks = 1